import { css } from "@emotion/css";
import { useRouter } from "next/router";
import React from "react";
import useBackground from "../../hooks/useBackground";

const BackgroundWhiteBluePurple = "/images/BackgroundWhiteBluePurple.png";

import {
  TextH2,
  TextH3,
  TextSecondary,
} from "../DesignSystem/DesignSystemText";
import LayoutCol from "../DesignSystem/Layout/LayoutCol";
import LayoutContainer from "../DesignSystem/Layout/LayoutContainer";

function getErrorComponent(errorMsg: string | undefined) {
  switch (errorMsg) {
    case "GasLimitExceeded":
      return (
        <>
          <TextH2>Unable to submit transaction!</TextH2>
          <TextSecondary>
            We&apos;re unable to submit your transaction as the gas fees on the
            blockchain are too high. Please try again later.
          </TextSecondary>
        </>
      );
    default:
      return (
        <>
          <TextH2>Oh no! We ran into an error</TextH2>
          <TextSecondary>
            Get in touch with us on{" "}
            <a href="https://discord.com/invite/v8JtC7sGuG">Discord</a> and we
            can help you out!
          </TextSecondary>
        </>
      );
  }
}

const GenericErrorPage: React.FC<{
  errorType?: string;
}> = (props) => {
  useBackground(BackgroundWhiteBluePurple);

  const router = useRouter();

  return (
    <>
      <LayoutContainer
        className={css`
          position: absolute;
          top: 0;
          bottom: 0;
        `}
        center={true}
      >
        <LayoutCol
          className={css`
            height: 100%;
          `}
          alignX="center"
          alignY="center"
        >
          <p
            className={css`
              label: ErrorPageIcon;
              font-size: 70rem !important;
              margin-top: 0px;
              margin-bottom: 0px;
            `}
          >
            🥺
          </p>
          {props.errorType === "notFound" ? (
            <div className="mt-4">
              <TextH3>
                Kudos not found,{" "}
                <span
                  className={css`
                    text-decoration: underline;
                    color: blue;
                    cursor: pointer;
                  `}
                  onClick={() => {
                    router.push("/create");
                  }}
                >
                  send
                </span>{" "}
                one now
              </TextH3>
            </div>
          ) : (
            getErrorComponent(props.errorType)
          )}
        </LayoutCol>
      </LayoutContainer>
    </>
  );
};

export default GenericErrorPage;
